// @ts-nocheck
import React, { useContext, useEffect, useRef, useState } from 'react';
import { Form, Row, Col, Input, Button } from 'antd';
import Message from 'shared_components/message';
import { LOGGEDIN_USER_DATA } from 'global_config/constant-global';

import { updateTimeoutAPI } from 'services/system_setup/fixed_values';
import { UserAccessContext } from 'context/userAccess';

export default function SetTimeout(props){
    const { userAccess } = useContext(UserAccessContext);
    const updateRight = userAccess['systemSetup'].update;

    const formRef = useRef();
    const loggedinUser = JSON.parse(sessionStorage.getItem(LOGGEDIN_USER_DATA));
    const [allDisabled, setAllDisabled] = useState(false)

    useEffect(()=> {
        if(updateRight === 'TRUE'){
            setAllDisabled(false)
        }else{
            setAllDisabled(true)
        }
    }, [updateRight])

    async function handleSubmit(formValues){
        const userID = loggedinUser.userID;
        try {
            const res = await updateTimeoutAPI(formValues, userID)
            if(res.data.fixed_value_id !== undefined){
                Message.success({ message: 'VAT PERCENTAGE SUCCESSFULLY UPDATED' });
                window.location.reload(false);
            }else{
                Message.success({ message: 'VAT PERCENTAGE ERROR: NOT UPDATED' });
            }

        } catch (error) {
            console.log('Update Vat Percent Error :', error);
            Message.error(error);
        }
    };
    
    return(
        <div>
            <Form
                // layout='vertical'
                onFinish={handleSubmit}
                ref={formRef}
            >
                <Row gutter={[8, 1]} align='middle'>
                    <Col span={3} >TIMEOUT AFTER :</Col>
                    <Col className="gutter-row" span={2} >
                        <Form.Item name='minutes'
                            // initialValue={ props.timeoutMin }
                        >
                            <Input disabled={allDisabled}></Input>
                        </Form.Item>
                    </Col>
                    <Col span={2} >MINUTES</Col>
                    <Col className="gutter-row" span={6} >
                        <Form.Item>
                            <Button
                                type="primary"
                                htmlType='submit'
                                disabled={allDisabled}
                            >
                                SAVE
                            </Button>
                            {/* <Button style={{ marginLeft: '5px' }} >
                                Clear
                            </Button> */}
                        </Form.Item>
                    </Col>
                    {/* <Col span={12}></Col> */}
                </Row>
                <Row gutter={[8, 1]} align='middle'>
                    <Col style={ {marginTop:'10px'} }>
                        <h3>Current System Timeout : {props.timeoutMin} minute/s</h3>
                    </Col>
                </Row>
            </Form>
        </div>
    )
};